import {
  CurrencyType,
  CurrencyUnit,
} from "@/core/services/api/interfaces/manager/CurrencyUnit";

export const resetObject = (object: object): object => {
  for (const i in object) {
    delete object[i];
  }

  return object;
};

export const scrollToFirstInput = (inputs: string[]): void => {
  for (const i in inputs) {
    const inputName = inputs[i];
    const inputGroup = document.getElementsByName(inputName);
    if (!inputGroup.length) {
      continue;
    }
    inputGroup[0].scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

export const scrollTo = (id: string): void => {
  const element = document.getElementById(id);
  if (!element) {
    return;
  }
  element.scrollIntoView({ behavior: "smooth", block: "center" });
};

export const setFormErrors = (
  form: HTMLFormElement | null | undefined,
  errors: { [index: string]: string[] } | object
): void => {
  console.log(form, errors);
  if (!form) {
    return;
  }
  for (const field in errors) {
    const fieldErrors = errors[field];
    if (fieldErrors) {
      let error = fieldErrors;
      if (Array.isArray(fieldErrors)) {
        error = fieldErrors.join("\n");
      }
      form?.setFieldError(field, error);
    }
  }
  const keys = Object.keys(errors);
  if (!keys.length) {
    form.setErrors({});
    form.setTouched(true);

    return;
  }
  scrollToFirstInput(keys);
};

export const currencyPlaceholderText = (unit: number | null): string => {
  return currencyFullPlaceholderText(unit, null);
};

export const currencyFullPlaceholderText = (
  unit: number | null,
  currency: string | null
): string => {
  return "0." + "0".repeat(unit || 2) + (currency ? ` ${currency}` : "");
};

export const renderCrypto = (
  amount: number | string,
  crypto: CurrencyUnit
): string => {
  let subUnit = 8;
  if (typeof amount === "string") {
    amount = parseFloat(amount);
  }
  if (crypto.sub_unit < subUnit) {
    subUnit = crypto.sub_unit;
  }
  if (!amount || Number.isInteger(amount)) {
    return amount.toFixed(subUnit);
  }
  const length = amount.toString().split(".")[1].length;
  if (length < subUnit) {
    return amount.toString() + "0".repeat(subUnit - length);
  }
  return amount.toString();
};

export const renderMoney = (
  amount: number | string,
  currency: string,
  currency_type: CurrencyType
): string => {
  if (CurrencyType.CRYPTO === currency_type) {
    return `${currency} ${amount}`;
  }
  if (typeof amount === "string") {
    amount = Number(amount);
  }

  return amount.toLocaleString("en-US", {
    style: "currency",
    currency,
  });
};

export const convert = (
  value: number | string | null | undefined,
  rate: number,
  side: "sell" | "buy",
  currency?: CurrencyUnit | null
): number => {
  if (null === value || typeof value === "undefined") {
    return 0;
  }
  if (typeof value === "string") {
    value = parseFloat(value);
  }

  const converted = side === "buy" ? value * rate : value / rate;
  console.log(value, converted, rate, side, currency);

  return parseFloat(converted.toFixed(currency?.sub_unit || 2));
};

export const getIndefiniteArticlesByPortalName = (
  portalName: string
): string => {
  const startsWithLowercase = ["a", "e", "i", "o", "u"].includes(
    portalName[0].toLowerCase()
  );
  return startsWithLowercase ? "an" : "a";
};

export const includeScript = (
  src: string,
  attributes: { [index: string]: string },
  onBeforeLoad?: () => void,
  onLoad?: () => void
) => {
  const script = document.createElement("script");
  script.src = src;
  for (const key in attributes) {
    script.setAttribute(key, attributes[key]);
  }
  if (onBeforeLoad) {
    onBeforeLoad();
  }
  if (onLoad) {
    script.onload = onLoad;
  }

  document.head.appendChild(script);
};

export const recursivelySetParam = (
  target: { [index: string]: any },
  attr: string,
  value: any
) => {
  if (!attr.includes(".")) {
    target[attr] = value;

    return;
  }

  const attrParts = attr.split(".");
  const firstPart = attrParts.shift();
  if (!firstPart) {
    return recursivelySetParam(target, attr, value);
  }
  if (!target[firstPart]) {
    target[firstPart] = {};
  }
  if (attrParts.length > 0) {
    return recursivelySetParam(target[firstPart], attrParts.join("."), value);
  }
  target[firstPart] = value;
};
